import { ModelSagres } from "../../model-sagres"

export class Perfil extends ModelSagres {
    Id: number
    Sigla?: string
    Descricao: string
    Oculto?: string
    ControleInterno?: string


    constructor(obj?: any) {
        super();
        //console.log(obj)
        if (obj) {
            if (obj.Id) this.Id = +obj.Id
            if (obj.Sigla) this.Sigla = obj.Sigla
            if (obj.Descricao) this.Descricao = obj.Descricao
            if (obj.Oculto) this.Oculto = obj.Oculto
            if (obj.ControleInterno) this.ControleInterno = obj.ControleInterno

            //Api nest

            if (obj.ID) this.Id = +obj.ID
            if (obj.SIGLA) this.Sigla = obj.SIGLA
            if (obj.DESCRICAO) this.Descricao = obj.DESCRICAO
            if (obj.OCULTO) this.Oculto = obj.OCULTO
            if (obj.CONTROLE_INTERNO) this.ControleInterno = obj.CONTROLE_INTERNO

         
        }
    }
}
